export default __webpack_public_path__ + "static/media/log-out.316dd325.svg";